import React, { useState } from "react";
import TableForData from "~/components/shared/datatable/table";
import { useSelector } from "~/redux/store";
import { columns } from "./column";
import { useGetJSAsQuery } from "~/redux/api/dailyOps";
import { RowSelectionState } from "@tanstack/react-table";
import { NavLink } from "react-router-dom";
import { Icon } from "~/components/ui";

const JSAPage: React.FC = () => {
  const searchInput = useSelector((state) => state.common.searchInput);
  const [pageSize, setPageSize] = useState(30);
  const [page, setPage] = useState(1);
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  const {
    data: response,
    isLoading,
    isFetching,
  } = useGetJSAsQuery({
    pageNumber: page,
    pageSize,
    searchTerm: searchInput,
  });

  const data = response?.result?.data || [];
  const meta = response?.result;

  return (
    <div>
      <TableForData
        title="Job Safety Analysis (JSA)"
        data={data}
        columns={columns as any}
        isLoading={isLoading || isFetching}
        setPage={setPage}
        setPageSize={setPageSize}
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
        meta={{
          pageIndex: meta?.pageIndex || 1,
          pageCount: meta?.pageCount || 1,
          totalRecordCount: meta?.totalRecordCount || 0,
          numberOfPagesToShow: 5,
          startPageIndex: 1,
          stopPageIndex: meta?.pageCount || 1,
          pageSize,
          actions: (
            <div className="flex justify-end w-full">
              <NavLink
                to="/daily-ops/jsa/create"
                className="flex items-center gap-2 rounded-2xl bg-secondary-500 px-4 py-2 text-sm shrink-0"
              >
                <Icon name="Plus" className="h-4 w-4" />
                <span>Create</span>
              </NavLink>
            </div>
          ),
        }}
      />
    </div>
  );
};

export default JSAPage;
